export default function dsSet(path, value) {
	return (dispatch) => {
		dispatch({
			type: 'SET_STORE_VALUE',
			payload: { path, value },
		});
	};
}